



















































































































import { Component } from "vue-property-decorator";
import ClientDataSectionDialogComponent from "./ClientDataSectionDialog.vue";
import { ProjectDetails } from "../../../data/models/ProjectDetails";
import { getTargetAppVersion } from "@/data/repository/ClientRepository";
import ConfirmationDialogComponent from "@/components/common/ConfirmationDialog.vue";

@Component({
  components: {
    "confirmation-dialog": ConfirmationDialogComponent,
  },
})
export default class ContactSectionComponent extends ClientDataSectionDialogComponent {
  showTitleInput = getTargetAppVersion() >= 1064;

  private snapshotTitle = "";
  private snapshotFirstName = "";
  private snapshotLastName = "";
  private snapshotEmail = "";
  private snapshotFloor = "";
  private snapshotPhone = "";
  private snapshotMobilePhone = "";
  private snapshotNote = "";

  hasInitialData(): boolean {
    const c = this.projectDetails.clientData.contact;
    if (!c) return false;
    return !!(c.title || c.firstName || c.lastName || c.emailAddress || c.floor || c.phone || c.mobilePhone || c.note);
  }

  takeSnapshot(): void {
    const c = this.projectDetails.clientData.contact ?? {};
    this.snapshotTitle = c.title ?? "";
    this.snapshotFirstName = c.firstName ?? "";
    this.snapshotLastName = c.lastName ?? "";
    this.snapshotEmail = c.emailAddress ?? "";
    this.snapshotFloor = c.floor ?? "";
    this.snapshotPhone = c.phone ?? "";
    this.snapshotMobilePhone = c.mobilePhone ?? "";
    this.snapshotNote = c.note ?? "";
  }

  get hasChanged(): boolean {
    const c = this.projectDetails.clientData.contact ?? {};
    return (c.title ?? "") !== this.snapshotTitle
      || (c.firstName ?? "") !== this.snapshotFirstName
      || (c.lastName ?? "") !== this.snapshotLastName
      || (c.emailAddress ?? "") !== this.snapshotEmail
      || (c.floor ?? "") !== this.snapshotFloor
      || (c.phone ?? "") !== this.snapshotPhone
      || (c.mobilePhone ?? "") !== this.snapshotMobilePhone
      || (c.note ?? "") !== this.snapshotNote;
  }

  async show(projectDetails: ProjectDetails) {
    if (!projectDetails.clientData.contact) {
      projectDetails.clientData.contact = {};
    }

    return this.showDialog(
      this.$t("clientData.contact").toString(),
      projectDetails
    );
  }
}
